var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout md-alignment-center-center container gray-6 bg new-globals"},[_c('org-selector',{on:{"orgChange":_vm.onOrgChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }